export default function() {
  return `
body {
  font-family: Bould,sans-serif;
}`
}
